import CodiSystem from '../codiSystem/index';

// todo: 暂时选择全量更新方式, 一张图纸最多5600个组件
function updateCodiSystem(): void {
    if (typeof isMochaSys !== 'undefined') {
        CodiSystem.updateAllSync();
        return;
    }

    // 异步更新
    CodiSystem.updateAllAsync();
}

export {
    updateCodiSystem
};
